




















































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import AppConsts from "../../../lib/appconst";
import _ from "lodash";
import DateTimeMixin from "@/components/mixin/date-time-mixin";
import moment from "moment";
import Customer from "../../../store/entities/customers/customer";

class PagePoReceiptRequest extends PageRequest {
  keyword: string;
  fromDate: Date;
  toDate: Date;
  customerId: number;
  clientCode: string;
  warehouseCode: string;
}
@Component
export default class PoReceipt extends mixins(
  ListMixin,
  DateTimeMixin,
  AbpBase
) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  namespace = "poReceipt";
  pagerequest: PagePoReceiptRequest = new PagePoReceiptRequest();
  clients = [];
  warehouses = [];
  spinShow: boolean = false;
  creationTime: Date[] = [];
  customers: Array<Customer> = new Array<Customer>();
  customerKeyword: string = "";
  customerLoading: boolean = false;
  searchCustomer_OnPress = _.debounce(
    this.searchCustomers,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );
  get store() {
    return this.$store.state.poReceipt;
  }
  isClient() {
    return this.$store.state.session.client != null;
  }
  isTenant() {
    return this.$store.state.session.tenant != null;
  }
  get client() {
    return this.$store.state.session.client;
  }
  get tenant() {
    return this.$store.state.session.tenant;
  }
  async searchCustomers(keyword) {
    if (Util.isEmpty(keyword)) return;
    this.customerLoading = true;
    this.$store
      .dispatch({
        type: "customer/searchCustomerForSelect",
        data: {
          keyWord: keyword,
        },
      })
      .then((result) => {
        this.customers = result;
      })
      .finally(() => {
        this.customerLoading = false;
      });
  }
  async getClients() {
    await this.$store
      .dispatch({
        type: "client/getListForSelect",
        data: { hasAllItem: true },
      })
      .then(() => {
        this.clients = this.$store.state.client.clientsForSelect;
        if (!this.isClient())
          this.pagerequest.clientCode =
            this.clients.length === 0 ? "" : this.clients[0].code;
      });
  }
  async getWarehouses() {
    await this.$store
      .dispatch({
        type: "warehouse/getListForSelect",
        data: { hasAllItem: true },
      })
      .then(() => {
        var re = this.$store.state.warehouse.warehousesForSelect;
        if (!this.isTenant())
          this.pagerequest.warehouseCode = re.length === 0 ? "" : re[0].id;
        this.warehouses = re;
      });
  }
  get loading() {
    return this.store.loading;
  }
  preGetPage() {
    if (this.isClient()) {
      this.pagerequest.clientCode = this.client.code;
    }
    if (this.isTenant()) {
      this.pagerequest.warehouseCode = this.tenant.tenancyName;
    }
    if (
      this.creationTime.length > 0 &&
      !_.isNil(this.creationTime[0]) &&
      this.creationTime[0].toString() !== ""
    ) {
      this.pagerequest.fromDate = moment(this.creationTime[0])
        .startOf("d")
        .toDate();
    }else  this.pagerequest.fromDate = null;
    if (
      this.creationTime.length > 1 &&
      !_.isNil(this.creationTime[1]) &&
      this.creationTime[1].toString() !== ""
    ) {
      this.pagerequest.toDate = moment(this.creationTime[1])
        .endOf("d")
        .toDate();
    }else this.pagerequest.toDate = null;
  }
  get list() {
    var re = this.store.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  async created() {
    this.spinShow = true;
    try {
      await this.getClients();
      await this.getWarehouses();
      this.creationTime = Util.buildDefaultViewDate(7);
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }
  renderColumn() {
    var lineColumns = [];
    if (!this.isClient()) {
      lineColumns = [
        ...lineColumns,
        {
          title: Util.L("Client"),
          width: 120,
          key: "clientCode",
          render: (h: any, params: any) => {
            if (_.isNil(params.row.po) || _.isNil(params.row.po.client))
              return "";
            return h(
              "span",
              `${params.row.po.client.id} - ${params.row.po.client.shortName}`
            );
          },
        },
      ];
    }
    if (!this.isTenant()) {
      lineColumns = [
        ...lineColumns,
        {
          title: Util.L("Warehouse"),
          width: 120,
          key: "warehouseCode",
          render: (h: any, params: any) => {
            if (_.isNil(params.row.po) || _.isNil(params.row.po.warehouse))
              return "";
            return h(
              "span",
              `${params.row.po.warehouse.id} - ${params.row.po.warehouse.name}`
            );
          },
        },
      ];
    }
    return lineColumns;
  }
  get columns() {
    return [
      {
        title: Util.L("Order"),
        key: "orderNo",
        width: 50,
      },
      ...this.renderColumn(),
      {
        title: Util.L("PoReceiptCode"),
        key: "code",
        width: 150,
      },
      {
        title: Util.L("ExternalPoCode"),
        key: "poId",
        width: 150,
        render: (h: any, params: any) => {
          if (_.isNil(params.row.po)) return "";
          return h("span", `${params.row.po.externalCode}`);
        },
      },
      {
        title: Util.L("ContainerNum"),
        key: "containerNumber",
        width: 150,
        render: (h: any, params: any) => {
          if (_.isNil(params.row.po) || _.isNil(params.row.po.containerNumber))
            return "";
          return h("span", `${params.row.po.containerNumber}`);
        },
      },
      {
        title: Util.L("InvoiceNumber"),
        key: "invoiceNumber",
        width: 150,
        render: (h: any, params: any) => {
          if (_.isNil(params.row.po) || _.isNil(params.row.po.invoiceNumber))
            return "";
          return h("span", `${params.row.po.invoiceNumber}`);
        },
      },
      {
        title: `${Util.L("Qty")}`,
        key: "totalQty",
        width: 100,
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.totalQty));
        },
      },
      {
        title: Util.L("Customer"),
        key: "customerId",
        width: 150,
        render: (h: any, params: any) => {
          if (_.isNil(params.row.po) || _.isNil(params.row.po.customer))
            return "";
          return h(
            "span",
            `${params.row.po.customer.code} - ${params.row.po.customer.name}`
          );
        },
      },
      {
        title: Util.L("CreationTime"),
        key: "creationTime",
        width: 180,
        render: (h: any, params: any) => {
          return h("span", Util.toViewDateString(params.row.creationTime));
        },
      },
      {
        title: Util.L("Action"),
        width: 100,
        fixed: "right",
        slot: "action",
        align: "center",
      },
    ];
  }
}
